module.exports = __webpack_public_path__ + "static/img/why-1.ba9d4e55.jpg";